module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(_vm.value) ? _c('v-img', {
    attrs: {
      "aspect-ratio": 16 / 9,
      "height": "150",
      "src": _vm.value
    }
  }, [_c('v-card-title', [_c('v-chip', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("Current image")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Update picture")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": "Search background images",
      "append-icon": "search"
    },
    on: {
      "click:append": _vm.search,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.images), function(img) {
    return _c('v-flex', {
      key: img.id,
      staticClass: "text-xs-center",
      attrs: {
        "xs4": "",
        "md3": "",
        "lg2": ""
      }
    }, [_c('v-img', {
      staticClass: "image",
      attrs: {
        "aspect-ratio": 16 / 9,
        "src": img.urls.thumb
      },
      on: {
        "click": function($event) {
          return _vm.$emit('input', img.urls.regular)
        }
      }
    })], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14dc6727","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ImageSearch.vue
// module id = 1333
// module chunks = 9